<div class="background">
  <h3 mat-dialog-title>Edit {{ data.field }} of {{ data.property }}:</h3>
  @if (data.field == "Tags") {
  <mat-form-field class="full-width">
    <mat-label>{{ data.field }}</mat-label>
    <mat-select [formControl]="selectedProductTags" multiple>
      @for (productTag of (productTags$ | async); track productTag.id) {
      <mat-option id="{{ productTag.id }}" [value]="productTag">{{
        productTag.name
      }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  }

  <mat-card
    [ngClass]="{
      'status-edited': (editedValue$ | async) === true,
      'status-failed': (editedValue$ | async) === false,
      'status-not-edited': !editPressed
    }"
    class="edited-card"
  >
    <p *ngIf="!editPressed">Press Save to submit your change.</p>
    @if (editPressed) {
    <p *ngIf="(editedValue$ | async) === null">Editing...</p>
    <p *ngIf="(editedValue$ | async) === true">Your Change has been made.</p>
    <p *ngIf="(editedValue$ | async) === false">
      Your Change could not be made.
    </p>
    }
  </mat-card>

  <div [align]="'end'" mat-dialog-actions>
    <button [mat-dialog-close]="false" mat-raised-button>Cancel</button>
    <button
      (click)="editValue()"
      [disabled]="editPressed || areArraysEqual(values(), data.values)"
      color="primary"
      mat-raised-button
    >
      Save
    </button>
  </div>
</div>
